import Card from '@/components/card';
import { Container, Main } from '@/components/container';
import { NsList } from '@/components/customElements';
import Layout from '@/components/layout';
import { Tags } from '@/components/tags';
import { graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

type Props = {
  data: GatsbyTypes.TagsQuery;
  pageContext: {
    tag: string;
    type: string;
    typeregex: string;
  };
};

const TagsContainer = styled(Container)`
  grid-template:
    'title title title' auto
    '. main tags' auto / 1fr var(--main-width) 1fr;
  ${media.lessThan('large')`
    grid-template:
    'title .' auto
    'main tags' auto / var(--main-width) 1fr;
  `}
  ${media.lessThan('medium')`
    grid-template:
    'title' auto
    'tags' auto
    'main' auto / var(--main-width);
  `}
`;
const Title = styled.h1`
  grid-area: title;
  margin: 0;
`;
const List = styled(NsList)`
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--card-width));
  gap: var(--card-gap);
  justify-content: center;
`;

const TagsPage: React.VFC<Props> = ({
  data: { site, allFile, tags },
  pageContext: { type: t, tag },
}) => {
  const type: Page = t === 'posts' ? 'post' : 'work';
  return (
    <Layout type={type} desc="WORK一覧" siteMetadata={site.siteMetadata}>
      <TagsContainer>
        <Title>
          {type === 'work' ? 'Works' : 'Posts'}#{tag}
        </Title>
        <Main>
          <List>
            {allFile.nodes.map(({ childMarkdownRemark }) => (
              <li key={childMarkdownRemark.fields.slug}>
                <Card childMarkdownRemark={childMarkdownRemark} type={type} />
              </li>
            ))}
          </List>
        </Main>
        <Tags tags={tags} type={type} />
      </TagsContainer>
    </Layout>
  );
};

export const query = graphql`
  query Tags($tag: String!, $type: String!, $typeregex: String!) {
    allFile(
      filter: {
        childMarkdownRemark: { frontmatter: { tags: { eq: $tag } } }
        sourceInstanceName: { eq: $type }
      }
      sort: { fields: childrenMarkdownRemark___frontmatter___date, order: DESC }
    ) {
      nodes {
        childMarkdownRemark {
          excerpt(format: PLAIN, pruneLength: 100, truncate: true)
          frontmatter {
            date(formatString: "YYYY/MM/DD")
            title
            tags
            thumbnail {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO]
                  layout: FULL_WIDTH
                )
              }
            }
          }
          html
          fields {
            slug
          }
        }
      }
    }
    tags: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: $typeregex } }
    ) {
      group(field: frontmatter___tags) {
        name: fieldValue
        totalCount
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`;

export default TagsPage;
